import humps from 'humps'

import {isEmpty} from 'lodash'
import api from '@/lib/api'

export default {
  namespaced: true,

  state: {
    testersAll: [],

    casesFields: [
      {key: 'id', label: 'ID', sortable: true},
      {key: 'type', label: 'Type', sortable: true},
      {key: 'family', label: 'Family', sortable: true},
      {key: 'appl', label: 'Application', sortable: true},
      {key: 'func', label: 'Function', sortable: true},
      {key: 'soldtoId', label: 'Soldto ID', sortable: true},
      {key: 'contactId', label: 'Contact ID', sortable: true},
      {key: 'openDate', label: 'Opened', sortable: true},
      {key: 'priority', label: 'Priority', sortable: true},
      {key: 'status', label: 'Status', sortable: true},
      {key: 'desc', label: 'Short Desc.', sortable: true},
    ],
  },
  getters: {},
  mutations: {
    testersAll: (s, a) => (s.testersAll = isEmpty(a) ? [] : humps.camelizeKeys(a)),
  },
  actions: {
    async fetchTesters({commit}) {
      try {
        const resp = await api.tester.list()
        const sorted = resp.data.sort((a, b) =>
          a.contact.last_name > b.contact.last_name
            ? 1
            : a.contact.last_name == b.contact.last_name
            ? a.contact.first_name > b.contact.first_name
              ? 1
              : -1
            : -1
        )

        commit(
          'testersAll',
          sorted.map((x) => {
            x.selected = false
            return x
          })
        )
      } catch (e) {
        commit('testersAll', [])
      }
    },
  },
}
